import { Credits } from './../Common/Credits/Credits'
import { GoToTop } from './../Common/GoToTop'
import { OfflineHeader } from './../Header/OfflineHeader'


const Contact = () => {
    return (
        <>
            <OfflineHeader />

            <main className='container'>
                <h1 className='text-center fs-3 mt-5'>Comunícate con nosotros</h1>
                
                <a href='mailto:ux@ztudia.com' className='Btn__Ztudia--PrimaryOutline text-center mx-auto mt-5 text-decoration-none'><i className='bi bi-envelope'></i> ux@ztudia.com</a>
                <a href='tel:+524447077110' className='Btn__Ztudia--PrimaryOutline text-center mx-auto mt-4 text-decoration-none'><i className='bi bi-telephone'></i> (+52 444) 707 7110</a>
                <a href='#' className='Btn__Ztudia--PrimaryOutline text-center mx-auto mt-4 text-decoration-none'><i className='bi bi-whatsapp'></i> (+52 444) 707 7110</a>

                <div className='mt-5'> {/* bg-light pt-4 pb-3 */}
                    <p className='text-center mb-2'>Lunes a Viernes 08:30 a.m. a 05:30 p.m. - Sábados de 09:00 a.m. a 01:00 p.m.</p>
                    <p className='text-center'>Hora Central de México (GMT-6 / UTC-6)</p>
                </div>

                <p className='text-center mt-5 mb-2'>FIVE DIGITAL MINDS</p>
                <p className='text-center'>Calle Fuete 307, Fraccionamiento Parque Herradura, C.P. 78394, Villa de Pozos, San Luis Potosí, México</p>
            </main>

            <Credits />

            <GoToTop />
        </>
    )
}

export { Contact };